import { ReactElement } from 'react';

import { PatientNfzDepartmentUpdateCommand, PatientQuery } from '@dreryk/egabinet-patient-frontend-api';

import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';
import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';

import { translationKeys } from '../translations';

import { NfzDepartmentFormBean, NfzDepartmentFormController } from './form/PatientNfzDepartmentForm.types';

type PatientNfzDepartmentUpdateModalConfirmButtonProps = {
   handleSubmit: NfzDepartmentFormController['handleSubmit'];
   onSuccess: VoidFunction;
   onFault: VoidFunction;
   patientId: number;
};

export const PatientNfzDepartmentUpdateModalConfirmButton = (
   props: PatientNfzDepartmentUpdateModalConfirmButtonProps
): ReactElement => {
   const { executeAsync: updatePatientNfzDepartment } = useCqrsCommand<void, NfzDepartmentFormBean>(
      (parameters) => {
         const command = new PatientNfzDepartmentUpdateCommand();
         command.patientId = props.patientId;
         command.nfzDepartmentId = parameters.nfzDepartment!.id;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(translationKeys.patientNFZDepartmentSuccessfullyUpdated);
            refetchCqrsQuery(PatientQuery);
            props.onSuccess();
         },
         onUnexpectedError: () => {
            props.onFault();
         },
      }
   );
   return <ModalConfirmButton label={translationKeys.save} onClick={props.handleSubmit(updatePatientNfzDepartment)} />;
};
